import { Outlet } from "react-router-dom";
import Header from "../../components/Shared/Header";
const Map = () => {
  return (
    <div className="bg-white h-full">
      <Header title="Selectionnez un client dans Navigation " />
      <Outlet />
    </div>
  );
};

export default Map;
